var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGlobe(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 351,
    height: 376,
    viewBox: "0 0 351 376",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M72.6229 33.5522C91.2618 21.7886 117.297 8.25202 138.751 4.22086C201.04 -2.70678 220.162 0.976417 257.776 20.7948C274.792 29.7609 289.425 43.6618 302.471 56.7219C308.582 62.8394 312.146 71.4729 318.494 77.8279C325.303 84.6449 324.981 94.7469 328.613 103.155C333.954 115.52 337.504 130.545 340.42 143.678C343.289 156.606 348.853 169.287 348.853 182.513C348.853 201.155 350.399 221.658 345.105 239.547C342.597 248.02 340.824 257.024 337.89 265.249C334.576 274.537 327.167 281.625 323.553 290.67C311.382 321.131 282.67 339.168 255.714 355.113C229.175 370.813 196.811 375 166.605 375C152.856 375 138.582 370.395 125.283 367.308C109.534 363.652 93.9124 365.369 78.9946 358.115C31.2248 334.887 1.4104 283.012 1.4104 230.541C1.4104 196.857 1.79732 165.334 10.6868 132.703C20.8674 95.3331 38.5897 55.0317 72.6229 33.5522Z",
    stroke: "#954AF4",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M131.113 9.00049C149.251 56.7844 259.516 84.0868 288.284 46.9846",
    stroke: "#954AF4",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M154.74 38.3877C147.202 47.7316 125.955 78.6852 120.077 89.1464C114.485 99.0983 110.812 104.596 105.625 114.734C101.038 123.7 93.9066 135.849 89.624 144.96C81.4805 162.284 75.8216 173.136 66.4786 189.685C61.2754 198.9 53.2667 223.486 47.8841 238.672C39.0761 271.003 39.0761 261.206 39.0761 325.869",
    stroke: "#954AF4",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M188.811 58.2529C188.811 96.8141 171.089 140.867 159.587 176.948C153.296 196.681 144.607 215.779 137.567 235.294C131.723 251.496 126.757 268.51 119.764 284.26C113.013 299.467 98.1602 344.499 93.3915 360.014",
    stroke: "#954AF4",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M236.276 68.0509C236.276 86.8067 233.629 110.835 230.404 129.285C226.432 152.008 157.819 351.777 148.686 372.751",
    stroke: "#954AF4",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M262.725 63.9232C264.24 76.7475 265.756 89.5718 267.272 102.396C270.168 126.899 266.67 147.503 263.968 171.837C261.37 195.229 254.571 218.496 249.656 241.542C246.202 257.737 243.395 276.819 237.05 292.154C235.4 296.14 221.522 344.869 211.32 369.81",
    stroke: "#954AF4",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M286.889 47.787C289.197 81.0562 293.165 113.871 295.474 147.144C296.609 163.495 295.549 192.232 295.474 208.644C295.401 224.667 292.124 255.133 290.102 270.858C288.196 285.681 269.743 335.076 265.635 349.727",
    stroke: "#954AF4",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M75.6205 38.9917C75.6205 64.3718 108.197 82.876 127.906 93.023C138.774 98.6186 263.514 139.354 327.108 99.6281",
    stroke: "#954AF4",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M29.4894 84.8589C46.787 128.659 128.187 153.106 149.554 162.273C167.754 167.334 187.595 172.638 207.043 175.006C236.26 178.564 271.379 182.638 297.406 168.162C309.202 161.602 322.02 154.575 333.669 148.744",
    stroke: "#954AF4",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5276 147.054C34.8553 170.408 60.0285 192.316 88.737 208.215C122.54 226.935 235.532 260.57 350 208.215",
    stroke: "#954AF4",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M0.999939 220.336C18.6467 231.132 94.3337 271.765 126.659 283.49C161.762 296.223 244.18 306.409 319.475 299.788",
    stroke: "#954AF4",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlobe);
export default __webpack_public_path__ + "static/media/globe.dff41a9cf04819be84d2d21f525e22e2.svg";
export { ForwardRef as ReactComponent };